import papa from 'papaparse'
import React from 'react'
import Body from './Body'
import Footer from './Footer'

const useGetMultiplyCityAdvancedTrackingPopup = ({
  onConfirm,
  onClose,
  isCanBeConfirmed,
  setCriticalError,
  setFile,
  error,
  warning,
  setWarning,
  setCodesTable,
  citiesArray: campaignCitiesArray,
  isCodesUploading,
}) => {
  const title = 'Upload codes file'

  const onFileUpload = (entryFiles, ...rest) => {
    setCriticalError(null)
    setWarning(null)
    if (entryFiles.length) {
      setFile(entryFiles[0])
      papa.parse(entryFiles[0], {
        complete: function(results, file) {
          const data = results.data
          const codesArray = []
          const linksArray = []
          const citiesArray = []

          data.forEach((dataItem, rowIndex) => {
            if (rowIndex === 0) {
              return
            }
            const code = dataItem[0]
            const link = dataItem[1]
            const city = dataItem[2]
            if (code || link || city) {
              codesArray.push(code || '')
              linksArray.push(link || '')
              citiesArray.push(city || '')
            }
          })

          //Validate that required headers exist in file in A1:C1:
          if (
            data[0][0].trim().toUpperCase() !== 'CODE' ||
            data[0][1].trim().toUpperCase() !== 'LINK' ||
            data[0][2].trim().toUpperCase() !== 'CITY'
          ) {
            setCriticalError(
              'Header value missing or incorrect. Please follow the instructions in the template and try again.',
            )
            return
          }

          //If file does not contain any required values:
          if (
            codesArray.includes('') ||
            linksArray.includes('') ||
            citiesArray.includes('') ||
            codesArray.length === 0 ||
            linksArray.length === 0 ||
            citiesArray.length === 0
          ) {
            setCriticalError(
              'No codes or links found in file. Please review and try again.',
            )
            return
          }

          if (codesArray.find(code => code.length > 12)) {
            setCriticalError('Codes can not be longer than 12 characters.')
            return
          }

          let shouldStop = false
          citiesArray.forEach(city => {
            if (!campaignCitiesArray.find(item => item.name === city)) {
              setCriticalError(
                `${city} is not a valid city for this campaign. Please review the file and try again.`,
              )
              shouldStop = true
            }
          })

          if (shouldStop) {
            return
          }
          //If client uploads csv file with not relevant city name in city column:
          //TODO

          //If client uploads csv file that contains duplicate codes:
          const uniqueCodes = Array.from(new Set(codesArray))
          if (codesArray.length !== uniqueCodes.length) {
            setWarning('Caution: file contains duplicate codes.')
          }
          const formattedData = []
          data.forEach((row, index) => {
            if (index !== 0 && row[0] && row[1] && row[2]) {
              formattedData.push({
                code: row[0],
                link: row[1],
                cityId: campaignCitiesArray.find(
                  currentCity => currentCity.name === row[2],
                ).id,
              })
            }
          })
          setCodesTable(formattedData)
        },
      })
    }
  }

  return {
    body: (
      <Body
        error={error || warning}
        onFileUpload={onFileUpload}
        setError={setCriticalError}
        setFile={setFile}
      />
    ),
    footer: (
      <Footer
        onConfirm={onConfirm}
        onClose={onClose}
        isCanBeConfirmed={isCanBeConfirmed}
        isCodesUploading={isCodesUploading}
      />
    ),
    title: title,
  }
}

export default useGetMultiplyCityAdvancedTrackingPopup
